import React from "react";

export function warningCount(snapshot, date) {
  if (!snapshot) return null;
  return date ? snapshot.by_date?.[date] ?? null : snapshot.total ?? null;
}

export function ComparisonMetric({ label, before, after, tone = "text-slate-900" }) {
  return <span className="flex flex-wrap items-center gap-3 text-sm leading-5">
    <span className="font-medium text-slate-600">{label}</span>
    <span className={`shrink-0 font-semibold tabular-nums ${tone}`}>{before} → {after}</span>
  </span>;
}

export function ComplianceCount({ comparison, date, label = "Labor law warnings", metric = false }) {
  if (!comparison?.enabled) return null;
  const before = warningCount(comparison.before, date);
  const after = warningCount(comparison.after, date);
  const tone = before !== null && after !== null && after < before
    ? "text-emerald-700" : before !== null && after !== null && after > before
    ? "text-rose-700" : "text-slate-900";
  if (metric) return <ComparisonMetric label={label} before={before ?? "Unavailable"}
    after={after ?? "Unavailable"} tone={tone} />;
  return <span className="text-xs font-medium text-slate-600">
    {label}: <span className={`font-semibold ${tone}`}>
      {before ?? "Unavailable"} → {after ?? "Unavailable"}
    </span>
  </span>;
}

export default function ScheduleComplianceComparison({ comparison, date, metric = false }) {
  if (!comparison?.enabled) return null;
  const before = warningCount(comparison.before, date);
  const after = warningCount(comparison.after, date);
  const isClear = before === 0 && after === 0;
  return <section aria-label={date ? "Daily labor law comparison" : "Weekly labor law comparison"} className="min-w-0">
    {isClear && metric ? <div className="flex items-center gap-3 text-sm leading-7">
      <span className="font-medium text-slate-600">Labor law warnings</span>
      <span className="inline-flex items-center gap-2 font-semibold text-slate-900">
        <span aria-hidden="true" className="flex h-5 w-5 items-center justify-center rounded-full bg-emerald-700 text-xs text-white">✓</span>None
      </span>
    </div> : <ComplianceCount comparison={comparison} date={date} metric={metric} />}
  </section>;
}
